import SignInPage from "../components/SignInPage";
import Spinner from "../components/Spinner";
import TopBar from "../components/TopBar";
import AuthContext from "../store/AuthContext";
import { SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";
import { passiveSupport } from "passive-events-support/src/utils";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import Cashier from "./Cashier";

passiveSupport({
  events: ["touchstart", "touchmove"],
});

const rebuildURL = (selectedEmail, selectedDeal) => {
  const urlData = {};
  if (selectedDeal) {
    urlData.deal = selectedDeal;
  }
  if (selectedEmail) {
    urlData.email = selectedEmail;
  }
  const params = Object.keys(urlData)
    .map((key) => `${key}=${urlData[key]}`)
    .join("&");

  switch (window.location.pathname) {
    case "/":
    case "/cashier": {
      window.history.pushState(
        "cashier",
        "",
        `${window.location.pathname}${params ? "?" + params : ""}`,
      );
      break;
    }
  }
};

const LoggedButNoAccess = () => {
  const clerkAuth = useAuth();

  const { signOut } = clerkAuth;

  return (
    <div>
      You are logged in, but do not have access to this app.
      <div className="cursor-pointer" onClick={signOut}>
        Log out
      </div>
    </div>
  );
};

const App = () => {
  const { selectedEmail, selectedDeal } = useSelector((state) => state.cashier);
  const { user = {} } = useSelector((state) => state.app);
  const authctx = useContext(AuthContext);
  const { overlay } = authctx;

  // build routes
  const signedInRoutes = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="*"
          element={
            <>
              <TopBar />
              <Cashier />
            </>
          }
        />
      </>,
    ),
  );

  // watch state and update url
  useEffect(() => {
    rebuildURL(selectedEmail, selectedDeal);
  }, [selectedEmail, selectedDeal]);

  return (
    <>
      <div id="modaldiv"></div>
      {!!overlay && <Spinner text={overlay} />}
      <SignedIn>
        {user?.access ? (
          <RouterProvider router={signedInRoutes} />
        ) : (
          <LoggedButNoAccess />
        )}
      </SignedIn>

      <SignedOut>
        <SignInPage />
      </SignedOut>
    </>
  );
};

export default App;
